export default __webpack_public_path__ + "static/media/keyFeature_4.93f7bcee.svg";